import React, { useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

interface TipsBoxProps {
  iconImage?: string;
  heading?: string;
  subText?: string;
  discreption?: string;
}

const TipsBox: React.FC<TipsBoxProps> = ({
  heading,
  iconImage,
  subText,
  discreption,
}) => {
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("md"));
  const [isExpanded, setIsExpanded] = useState(isXsOrSm ? false : true);

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Box
      sx={{
        backgroundColor: isXsOrSm ? "#d5fafcff" : "#FFFFFF",
        borderRadius: isXsOrSm ? "10px" : "6px",
        border: isXsOrSm ? "1px solid #00B3B5" : "",
        boxShadow: "0px 4px 18px 0px #4B465C1A;",
        padding: isXsOrSm ? "10px 12px" : "20px 24px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      <Box
        onClick={
          isXsOrSm
            ? () => handleToggleExpand()
            : () => {
                console.log("");
              }
        }
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {iconImage && (
            <Box
              component="img"
              src={iconImage}
              alt={heading || "icon"}
              sx={{
                width: "24px",
                height: "24px",
                borderRadius: "6px",
                padding: "4px",
                backgroundColor: "#E6F7FF",
                objectFit: "contain",
              }}
              onError={(e) => {
                e.currentTarget.src =
                  "https://placehold.co/24x24/e6f7ff/1890ff?text=!";
              }}
            />
          )}
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              fontSize: isXsOrSm ? "14px" : "13px",
              lineHeight: "100%",
              letterSpacing: "1px",
              color: "#00B3B5",
              textTransform: "uppercase",
              verticalAlign: "middle",
            }}
          >
            {heading}:
          </Typography>
        </Box>

        {isXsOrSm && (
          <Box>
            {isExpanded ? (
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "13px",
                  lineHeight: "100%",
                  color: "#6f6b7d",
                  mb: "6px",
                  verticalAlign: "middle",
                }}
              >
                Hide
              </Typography>
            ) : (
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "13px",
                  lineHeight: "100%",
                  color: "#00B3B5",
                  mb: "6px",
                  verticalAlign: "middle",
                }}
              >
                Show
              </Typography>
            )}
          </Box>
        )}
      </Box>

      {isExpanded && (
        <Box sx={{ py: 1 }}>
          {subText && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontWeight: 600,
                fontSize: "13px",
                lineHeight: "100%",
                color: "#6f6b7d",
                mb: "6px",
                verticalAlign: "middle",
              }}
            >
              {subText}
            </Typography>
          )}
          {discreption && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "100%",
                color: "#6f6b7d",
                verticalAlign: "middle",
              }}
            >
              {discreption}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default TipsBox;
